/** Flat variant
 * @deprecated Use `primary` instead
 */
type FlatVariant = 'flat';

/** Tonal variant
 * @deprecated Use `secondary` instead
 */
type TonalVariant = 'tonal';

/**
 * variants
 * - primary
 * - secondary
 * - text
 * - outlined
 * - flat (deprecated) - Use `primary` instead
 * - tonal (deprecated) - Use `secondary` instead
 */
export type BvBtnVariant = 'primary' | 'secondary' | 'text' | 'outlined' | FlatVariant | TonalVariant;

/** Maps design-system names to Vuetify `VBtn` variants. */
export const BV_BTN_VUETIFY_VARIANT = {
  primary: 'flat',
  flat: 'flat',
  secondary: 'tonal',
  tonal: 'tonal',
  text: 'text',
  outlined: 'outlined',
} as const satisfies Record<BvBtnVariant, 'flat' | 'tonal' | 'text' | 'outlined'>;

export function toVuetifyBtnVariant(variant: BvBtnVariant): (typeof BV_BTN_VUETIFY_VARIANT)[BvBtnVariant] {
  return BV_BTN_VUETIFY_VARIANT[variant] ?? 'flat';
}

export function toBvBtnVariant(variant: BvBtnVariant): BvBtnVariant {
  switch (variant) {
    case 'primary':
    case 'flat':
      return 'primary';
    case 'secondary':
    case 'tonal':
      return 'secondary';
    case 'text':
      return 'text';
    case 'outlined':
      return 'outlined';
    default:
      return 'primary';
  }
}
